var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.item.loading ? _c('v-list-item', {
    attrs: {
      "three-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "text-truncate "
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', [_vm.hasOpenDetailListener() ? _c('a', {
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.emitOpenDetail.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.item.title) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.item.title) + " ")])]), _c('v-spacer'), _c('v-chip', {
    attrs: {
      "small": "",
      "color": _vm.item.statusColor,
      "dark": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("enums.RequestStatusEnum.".concat(_vm.item.status))) + " ")])], 1)]), !_vm.small ? _c('v-list-item-subtitle', {
    staticClass: "text-xs text-truncate"
  }, [!_vm.hideDate ? [_c('v-chip', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.date) + " ")])] : _vm._e()], 2) : _vm._e()], 1)], 1) : _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-three-line"
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }